export default __webpack_public_path__ + "static/media/card-fuzzy-start-gray.c57a9204.jpg";